import { useEffect, useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Switch,
  TextField,
} from '@mui/material';

import { EmailTemplateTypes } from '../../../utils/enums/userTypes';
import { createCampaign, updateCampaign } from '../../../api/campaign';

const CampaignEditorDialog = ({ open, campaign, onClose, onSaved }) => {
  const [form, setForm] = useState(campaign ?? {});

  useEffect(() => {
    setForm(campaign ?? {});
  }, [campaign]);

  const updateField = (field, value) => {
    setForm((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSave = async () => {
    const payload = {
      ...form,
      active: form.active ? 1 : 0,
    };

    if (payload.id) {
      await updateCampaign(payload.id, payload);
    } else {
      await createCampaign({
        ...payload,
        active: 1,
        created_at: new Date().toISOString(),
      });
    }

    onSaved();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth='md'>
      <DialogTitle>
        {form?.id ? 'Kampány szerkesztése' : 'Új kampány'}
      </DialogTitle>

      <DialogContent dividers>
        <Stack spacing={2} sx={{ mt: 1 }}>
          <TextField
            label='Üzenet típus'
            value={form.campaignTitle ?? ''}
            onChange={(e) => updateField('campaignTitle', e.target.value)}
            fullWidth
          />

          <TextField
            label='Érvényesség vége'
            type='date'
            value={
              form.campaignValidTo
                ? String(form.campaignValidTo).slice(0, 10)
                : ''
            }
            onChange={(e) => updateField('campaignValidTo', e.target.value)}
            InputLabelProps={{ shrink: true }}
            fullWidth
          />

          <FormControl fullWidth>
            <InputLabel>e-Mail template</InputLabel>
            <Select
              label='e-Mail template'
              value={form.mailTemplate ?? ''}
              onChange={(e) => updateField('mailTemplate', e.target.value)}
            >
              {EmailTemplateTypes.map((item) => (
                <MenuItem key={item.key} value={item.key}>
                  {item.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <TextField
            label='Üzenet szövege'
            value={form.mailContent ?? ''}
            onChange={(e) => updateField('mailContent', e.target.value)}
            multiline
            minRows={10}
            fullWidth
          />

          <FormControlLabel
            control={
              <Switch
                checked={Number(form.active) === 1 || form.active === true}
                onChange={(e) =>
                  updateField('active', e.target.checked ? 1 : 0)
                }
              />
            }
            label='Kampány aktív'
          />
        </Stack>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Mégse</Button>
        <Button variant='contained' onClick={handleSave}>
          Mentés
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CampaignEditorDialog;
